const sensorID = [
  { type: 'required', message: 'Sensor ID is required' },
  { type: 'pattern', message: 'Sensor ID must contain only numbers' },
]

export default { sensorID };
